// Shown to external users on a client whose Newton project hasn't been mapped yet. Avoids
// falling back to the default (wrong-client) Newton dashboard.
export const NewtonNotConfigured = () => (
  <div className='newton-not-configured'>
    <div className='newton-not-configured-card'>
      <h2 className='newton-not-configured-title'>Newton isn&apos;t set up for this client yet</h2>
      <p className='newton-not-configured-desc'>
        This client&apos;s Newton workspace hasn&apos;t been connected. Please reach out to your
        Tinuiti team, who can finish setting it up.
      </p>
    </div>
  </div>
);
